import { useEffect } from 'react';
import {setCabinetGLBFromCabinetsSet} from "../helpers/sqft3dArHelper";
import {setLookActiveCategory} from "../../../actions/lookFunctions";
import store from "../../../store";
import {setMultiLoader} from "../../../actions/actionFunctions";
import {SHAPE_PART_ID} from "../constants";

const useChangeCabinetsColor = (lookActiveFeature) => {
  useEffect(() => {
    // wi will display door styles for this category

    const state = store.getState()
    const {displayDoorsOnly} = state.serverState;


    setLookActiveCategory(SHAPE_PART_ID.top_cabinet);

    store.dispatch(setMultiLoader({activeStep: 0, visible: false, finished: false}));
    store.dispatch(setMultiLoader({activeStep: 0, visible: true, finished: false}));

    //todo update lower and bottom separately
    //sqftShapeManager.changeShapesFeatureIDIfColorWasChanged(lookActiveFeature);

    setCabinetGLBFromCabinetsSet(displayDoorsOnly).then(r => void r);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lookActiveFeature])
};

export default useChangeCabinetsColor;
